import { useEffect, useRef, useState } from "react";
import UseGame from "../stores/UseGame";
import gibberish1 from "/audio/gibberish_1.wav";
import gibberish2 from "/audio/gibberish_2.wav";

export default function HumanAudio() {
  const gibberishAudio = [gibberish1, gibberish2];
  const [noiseOne, setNoiseOne] = useState(gibberishAudio[0]);
  const audioGibRef = useRef();
  const [audioReady, setAudioReady] = useState(false);

  const clicked = UseGame((state) => state.clicked);

  function getRandom() {
    return Math.round(Math.random());
  }

  // const gibberishList = ["musician", "stage", "reader"];
  useEffect(() => {
    //if phase is ready reset position
    if (clicked !== "") {
      const i = getRandom();
      setNoiseOne(gibberishAudio[i]);
      if (audioReady) {
        audioGibRef.current.play();
      } else {
        audioGibRef.current.addEventListener(
          "canplaythrough",
          handleCanPlayThrough
        );
      }
    }
  }, [clicked]);

  const handleCanPlayThrough = () => {
    audioGibRef.current.play();
    setAudioReady(true);
  };

  return (
    <div>
      <audio ref={audioGibRef} src={noiseOne} />
    </div>
  );
}
